import React, { Suspense, lazy } from 'react';
import { store } from './store';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './Context/AuthContext';
import { ExamModeProvider } from './Context/ExamModeContext';
import ReactDOM from 'react-dom/client';
import ErrorPage from './Pages/ErrorPage';
import Loading from './Components/Logics/Loading';
import ProtectedRoute from './Components/Logics/ProtectedRoute';
import 'bootstrap/dist/css/bootstrap.min.css';

// Lazy load components
const RootLayout = lazy(() => import('./Pages/RootLayout'));
const HomePage = lazy(() => import('./Pages/HomePage'));
const Dashboard = lazy(() => import('./Pages/Dashboard'));
const FirstSecondary = lazy(() => import('./Pages/FirstSecondary'));
const SecondSecondary = lazy(() => import('./Pages/SecondSecondary'));
const ThirdSecondary = lazy(() => import('./Pages/ThirdSecondary'));
const Statistics = lazy(() => import('./Pages/Statistics'));
const VideoAccess = lazy(() => import('./Pages/VideoAccess'));
const VideoWatch = lazy(() => import('./Pages/VideoWatch'));
const EditVideo = lazy(() => import('./Pages/EditVideo'));
const LoginPage = lazy(() => import('./Pages/LoginPage'));
const RegisterPage = lazy(() => import('./Pages/RegisterPage'));
const StudentProfile = lazy(() => import('./Pages/StudentProfile'));
const ParentPortal = lazy(() => import('./Pages/ParentPortal'));
const AdminStudentProfile = lazy(() => import('./Pages/AdminStudentProfile'));

const router = createBrowserRouter([{
  path: '/',
  element: (
    <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
      <Loading />
    </article>}>
      <RootLayout />
    </Suspense>
  ),
  errorElement: <ErrorPage />,
  children: [
    {
      path: '/',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <HomePage />
        </Suspense>
      )
    },
    {
      path: '/Dashboard',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <Dashboard />
        </Suspense>
      )
    },
    {
      path: '/FirstSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <FirstSecondary />
        </Suspense>
      )
    },
    {
      path: '/FirstSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/SecondSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <SecondSecondary />
        </Suspense>
      )
    },
    {
      path: '/SecondSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/ThirdSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ThirdSecondary />
        </Suspense>
      )
    },
    {
      path: '/ThirdSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/Statistics',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <Statistics />
        </Suspense>
      )
    },
    {
      path: '/Statistics/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/VideoWatch',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoWatch />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/videos/edit/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <EditVideo />
        </Suspense>
      )
    },
    {
      path: '/login',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <LoginPage />
        </Suspense>
      )
    },
    {
      path: '/register',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <RegisterPage />
        </Suspense>
      )
    },
    {
      path: '/profile',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <StudentProfile />
        </Suspense>
      )
    },
    {
      path: '/admin/student/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <AdminStudentProfile />
        </Suspense>
      )
    },
    {
      path: '/parent',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute parentOnly={true} showMessage={true} redirectMessage="يجب تسجيل الدخول بكود الطالب للوصول لصفحة ولي الأمر">
            <ParentPortal />
          </ProtectedRoute>
        </Suspense>
      )
    }
  ],
},
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <ExamModeProvider>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ExamModeProvider>
  </AuthProvider>
);